(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bs-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bs-product-details')) {
  customElements.define('bs-product-details',class extends HTMLElement {
   connectedCallback() {
    if(this.dataset.ready)return;
    const source=this.querySelector('[data-bs-description]');
    const hero=this.closest('[data-bs-luxury-product]');
    if(!source)return;
    const nodes=Array.from(source.childNodes);
    const norm=s=>s.trim().replace(/\s+/g,' ').toLowerCase();
    const starters=new Set(['ideal for','full ingredient listing (inci names)','full ingredient list (inci names)','the botanical','the story behind aurelix™','the botanical composition','included in your set']);
    const start=nodes.findIndex(n=>/^H[2-4]$/.test(n.nodeName)&&starters.has(norm(n.textContent)));
    if(start<0)return;
    const level=Number(nodes[start].nodeName[1]);
    const standalone=new Set(['how to use','storage & shelf life','important information']);
    const chunks=[{key:'formulation',label:this.dataset.formulation,nodes:nodes.slice(0,start)}];
    for(const n of nodes.slice(start)) {
     if(/^H[2-4]$/.test(n.nodeName)&&(Number(n.nodeName[1])<=level||standalone.has(norm(n.textContent)))) {
      const label=norm(n.textContent);
      let key=label;
      if(/ingredient/.test(label))key='ingredients';
      else if(label==='rich in')key='nutrients';
      else if(/ideal for|skin benefits|body care benefits/.test(label))key='benefits';
      else if(/suitable skin|skin profile/.test(label))key='skin';
      else if(/texture|skin feel|aroma|aromatic/.test(label))key='texture';
      else if(/how to use|best time|your personal ritual/.test(label))key='application';
      else if(/storage|shelf life|product care|important information/.test(label))key='care';
      else if(label==='base'||label==='the botanical')key='formulation';
      chunks.push({key,label:this.dataset[key]||n.textContent.trim(),original:label,nodes:[n]});
     }else chunks[chunks.length-1].nodes.push(n);
    }
    const intro=hero?.querySelector('[data-bs-intro]');
    const lead=chunks[0].nodes.find(n=>n.nodeName==='P'&&n.textContent.trim().length>90);
    if(intro&&lead){intro.append(lead);chunks[0].nodes=chunks[0].nodes.filter(n=>n!==lead);}
    const grouped=new Map();
    for(const chunk of chunks){if(!chunk.nodes.some(n=>n.textContent.trim()||n.nodeName==='IMG'))continue;if(!grouped.has(chunk.key))grouped.set(chunk.key,{label:chunk.label,nodes:[]});grouped.get(chunk.key).nodes.push(...chunk.nodes);}
    let index=0;
    for(const group of grouped.values()) {
     const details=document.createElement('details'),summary=document.createElement('summary'),number=document.createElement('span'),label=document.createElement('span'),body=document.createElement('div');
     number.className='bs-details-index';number.textContent=String(++index).padStart(2,'0');number.setAttribute('aria-hidden','true');
     label.textContent=group.label;summary.append(number,label);body.className='bs-product-details__content';body.append(...group.nodes);details.append(summary,body);source.append(details);
    }
    const expand=this.querySelector('.bs-details-expand');expand.hidden=false;
    const sync=()=>{const all=Array.from(source.querySelectorAll('details')).every(d=>d.open);expand.textContent=all?this.dataset.collapse:this.dataset.expand;expand.setAttribute('aria-expanded',String(all));};
    expand.addEventListener('click',()=>{const all=Array.from(source.querySelectorAll('details')).every(d=>d.open);source.querySelectorAll('details').forEach(d=>d.open=!all);sync();});source.addEventListener('toggle',sync,true);sync();
    if(hero) {
     const tags=hero.querySelector('[data-bs-tags]');
     for(const key of ['skin','texture','benefits']) {
      const item=grouped.get(key)?.nodes.flatMap(n=>n.querySelectorAll?Array.from(n.querySelectorAll('li')):[]).find(n=>n.textContent.trim().length<65);
      if(tags&&item){const span=document.createElement('span');span.textContent=item.textContent;tags.append(span);tags.hidden=false;}
     }
     const fillStory=()=> {
      const story=hero.querySelector('[data-bs-story]'),copy=hero.querySelector('[data-bs-sensory-copy]');
      const sensory=chunks.filter(c=>c.key==='texture').sort((a,b)=>{const rank=c=>/skin feel/.test(c.original)?0:/aroma|aromatic/.test(c.original)?1:2;return rank(a)-rank(b);});
      const fallback=chunks.find(c=>c.original==='included in your set'||c.original==='the botanical architecture');
      if(story&&copy&&!copy.childNodes.length) {
       const entries=sensory.length?sensory:(fallback?[fallback]:[]);
       for(const c of entries.slice(0,2)){const n=c.nodes.find(n=>/^(P|UL|OL)$/.test(n.nodeName));if(n){const p=document.createElement('p');p.textContent=n.nodeName==='P'?n.textContent:Array.from(n.children).slice(0,3).map(li=>li.textContent.replace(/[.!]$/, '')+'.').join(' ');copy.append(p);}}
       if(copy.childNodes.length)story.hidden=false;
      }
      const ritual=hero.querySelector('[data-bs-ritual]'),steps=hero.querySelector('[data-bs-steps]');
      if(ritual&&steps&&!steps.childNodes.length) {
       const application=chunks.filter(c=>c.key==='application');
       const lines=application.flatMap(c=>c.nodes.flatMap(n=>n.nodeName==='P'?[n]:/^(UL|OL)$/.test(n.nodeName)?Array.from(n.children):[]));
       for(const [i,n] of lines.slice(0,3).entries()){const step=document.createElement('div'),num=document.createElement('span'),p=document.createElement('p');step.className='bs-lux-step';num.className='bs-lux-step-number';num.textContent=String(i+1).padStart(2,'0');p.textContent=n.textContent;step.append(num,p);steps.append(step);}
       if(steps.childNodes.length)ritual.hidden=false;
      }
     };
     fillStory();if(!hero.querySelector('[data-bs-ritual]'))requestAnimationFrame(fillStory);
    }
    this.dataset.ready='true';
   }
  });
 }
  } catch(e) { console.error(e); }
})();

})();
